function sanitizeData(node) {
  const nullVal1 = '32768';
  const nullVal2 = '-32768';
  const nullVal3 = '99999';
  const nullVal4 = '-99999';
  const newVal = '--';

  if (typeof node === 'object' && node !== null) {
    // loop through object keys
    for (const key in node) {
      // set key value to null if its a match
      if (node[key] === null) {
        node[key] = newVal;
      } else if (node[key]) {
        if (typeof node[key] === 'object' && node[key] !== null) {
          sanitizeData(node[key]);
        } else if (node[key].toString() === nullVal1 ||
					node[key].toString() === nullVal2 ||
					node[key].toString() === nullVal3 ||
					node[key].toString() === nullVal4) {
          node[key] = newVal;
        }
      }
    }
  }
  return node;
}

export default sanitizeData;

